import { lazy } from 'react';
const Adjust = lazy(() => import(
// webpackChunkName: 'Adjust'
'./icons/adjust.svg'));
const Alarm = lazy(() => import(
// webpackChunkName: 'Alarm'
'./icons/alarm.svg'));
const Attic_old = lazy(() => import(
// webpackChunkName: 'Attic_old'
'./icons/attic.svg'));
const BathHouse = lazy(() => import(
// webpackChunkName: 'BathHouse-tab'
'./icons/bathhouse.svg'));
const Bath = lazy(() => import(
// webpackChunkName: 'Bath'
'./icons/bath.svg'));
const Bedroom_old = lazy(() => import(
// webpackChunkName: 'Bedroom_old'
'./icons/bedroom.svg'));
const Children_old = lazy(() => import(
// webpackChunkName: 'Children_old'
'./icons/children.svg'));
const DoorSensor = lazy(() => import(
// webpackChunkName: 'DoorSensor'
'./icons/door-sensor.svg'));
const Garage_old = lazy(() => import(
// webpackChunkName: 'Garage_old'
'./icons/garage.svg'));
const Gauge = lazy(() => import(
// webpackChunkName: 'Gauge'
'./icons/gauge.svg'));
const Heater = lazy(() => import(
// webpackChunkName: 'Heater'
'./icons/heater.svg'));
const Home = lazy(() => import(
// webpackChunkName: 'Home'
'./icons/home.svg'));
const Kitchen_old = lazy(() => import(
// webpackChunkName: 'Kitchen_old'
'./icons/kitchen.svg'));
const Pump = lazy(() => import(
// webpackChunkName: 'Pump'
'./icons/pump.svg'));
const SmokeDetector = lazy(() => import(
// webpackChunkName: 'SmokeDetector'
'./icons/smoke-detector.svg'));
const Sofa = lazy(() => import(
// webpackChunkName: 'Sofa'
'./icons/sofa.svg'));
const Switch = lazy(() => import(
// webpackChunkName: 'Switch'
'./icons/switch.svg'));
const Radiator = lazy(() => import(
// webpackChunkName: 'Radiator'
'../heating-circuits/radiator.svg'));
const HeatingFloor = lazy(() => import(
// webpackChunkName: 'HeatingFloor'
'../heating-circuits/floor-heating.svg'));
export const custom_tab_icons = [
    {
        id: 0,
        render: Adjust,
        title: 'Управление',
        paid: false,
    },
    {
        id: 1,
        render: Alarm,
        title: 'Сигнализация',
        paid: false,
    },
    {
        id: 2,
        render: Attic_old,
        title: 'Чердак',
        paid: false,
    },
    {
        id: 3,
        render: BathHouse,
        title: 'Баня',
        paid: false,
    },
    {
        id: 4,
        render: Bath,
        title: 'Ванная',
        paid: false,
    },
    {
        id: 5,
        render: Bedroom_old,
        title: 'Спальня',
        paid: false,
    },
    {
        id: 6,
        render: Children_old,
        title: 'Детская',
        paid: false,
    },
    {
        id: 7,
        render: DoorSensor,
        title: 'Охрана',
        paid: false,
    },
    {
        id: 8,
        render: Garage_old,
        title: 'Гараж',
        paid: false,
    },
    {
        id: 9,
        render: Gauge,
        title: 'Датчики',
        paid: false,
    },
    {
        id: 10,
        render: Heater,
        title: 'Котёл',
        paid: false,
    },
    {
        id: 11,
        render: Home,
        title: 'Дом',
        paid: false,
    },
    {
        id: 12,
        render: Kitchen_old,
        title: 'Кухня',
        paid: false,
    },
    {
        id: 13,
        render: Pump,
        title: 'Насос',
        paid: false,
    },
    {
        id: 14,
        render: SmokeDetector,
        title: 'Датчик',
        paid: false,
    },
    {
        id: 15,
        render: Sofa,
        title: 'Гостиная',
        paid: false,
    },
    {
        id: 16,
        render: Switch,
        title: 'Управление',
        paid: false,
    },
    {
        id: 17,
        render: Radiator,
        title: 'Радиаторы',
        paid: false,
    },
    {
        id: 18,
        render: HeatingFloor,
        title: 'Тёплый пол',
        paid: false,
    },
    //     max_amount_id: 127 see parsing UiGroup.icons
];
